<template>
  <v-container>
    <v-row dense>
      <v-col cols="12">
        <show-field :value="item.name" :label="$t('delivery.cashRegister.labels.name')" icon="point_of_sale"/>
      </v-col>
      <v-col cols="12">
        <show-field :value="item.active ? $t('delivery.cashRegister.yes') : $t('delivery.cashRegister.no')" :label="$t('delivery.cashRegister.labels.active')" icon="verified"/>
      </v-col>
      <v-col cols="12" v-for="user in item.users" :key="user.id">
        <v-row dense>
          <v-col cols="12" sm="4">
            <show-field :value="user.username" :label="$t('delivery.cashRegister.labels.user')" icon="person"/>
          </v-col>
          <v-col cols="12" sm="4">
            <show-field :value="user.email" :label="$t('delivery.cashRegister.labels.email')" icon="email"/>
          </v-col>
          <v-col cols="12" sm="4">
            <show-field :value="user.role ? user.role.name : ''" :label="$t('delivery.cashRegister.labels.role')" icon="security"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ShowField} from '@dracul/common-frontend'

export default {
  name: 'CashRegisterShowData',
  components: {ShowField},
  props:{
    item: {type: Object, required: true}
  }
}
</script>
